import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import PageNotFound from 'views/Common/PageNotFound';

const ScheduledMessagesView = React.lazy(
  () => import('views/ScheduledMessages/ScheduledMessagesView')
);
const HomeView = React.lazy(() => import('views/Home/HomeView'));
const CbtBuilderRoutes = React.lazy(
  () => import('views/CbtBuilder/CbtBuilderRoutes')
);
const ChatView = React.lazy(() => import('views/Chat/ChatView'));
const NewsView = React.lazy(() => import('views/News/NewsView'));
const UsersRoutes = React.lazy(() => import('views/UserSearch/UsersRoutes'));
const ActionItemsView = React.lazy(
  () => import('views/ActionItems/ActionItemsCalendarView')
);
const RolesView = React.lazy(() => import('views/Roles/RolesView'));
const DocumentTemplatesView = React.lazy(
  () => import('views/DocumentTemplates/DocumentTemplatesView')
);
const TherapyDocumentView = React.lazy(
  () => import('views/TherapyUsers/TherapyDocumentView')
);
const ActionItemTriggersView = React.lazy(
  () => import('views/ActionItemTriggers/ActionItemTriggersView')
);
const UserSettingsView = React.lazy(
  () => import('views/Settings/UserSettingsView')
);
const TherapyCoursesView = React.lazy(
  () => import('views/TherapyCourses/TherapyCoursesView')
);
const TherapySessionsView = React.lazy(
  () => import('views/TherapySessions/TherapySessionsView')
);
const InsuranceView = React.lazy(() => import('views/Insurance/InsuranceView'));
const TherapyUsersView = React.lazy(
  () => import('views/TherapyUsers/TherapyUsersView')
);
const SystemPage = React.lazy(() => import('views/System/SystemPage'));
const DeadLettersPage = React.lazy(
  () => import('views/System/DeadLettersPage')
);
const EmailBuilderPage = React.lazy(
  () => import('views/System/EmailBuilderPage')
);
const MeetingsView = React.lazy(() => import('views/Meetings/MeetingsView'));
const AiAssistantView = React.lazy(
  () => import('views/AiAssistant/AiAssistantView')
);

const AuthenticatedRoutes = () => {
  return (
    <Routes>
      <Route index element={<HomeView />} />
      <Route path="chat" element={<ChatView />} />
      <Route path="users/*" element={<UsersRoutes />} />
      <Route
        // @deprecated - in favor of /users/clients
        path="coach/:cid/*"
        element={<Navigate to="/users/clients" replace />}
      />
      <Route path="coach/action_items/*" element={<ActionItemsView />} />
      <Route
        path="coach/scheduled_messages/*"
        element={<ScheduledMessagesView />}
      />
      <Route
        path="action_item_triggers/*"
        element={<ActionItemTriggersView />}
      />
      <Route path="insurance/*" element={<InsuranceView />} />
      <Route
        path="trucare_reports/*"
        element={<Navigate to="/insurance/trucare_reports" replace />}
      />
      <Route path="cbt/*" element={<CbtBuilderRoutes />} />
      <Route path="news/*" element={<NewsView />} />
      <Route path="roles/*" element={<RolesView />} />
      <Route path="document-templates" element={<DocumentTemplatesView />} />
      <Route path="therapy/users/:userId" element={<TherapyUsersView />} />
      <Route
        path="therapy/users/:userId/documents/:documentId"
        element={<TherapyDocumentView />}
      />
      <Route path="therapy/*" element={<TherapyCoursesView />} />
      <Route path="therapy-sessions/*" element={<TherapySessionsView />} />
      <Route path="meetings/*" element={<MeetingsView />} />
      <Route path="ai-assistant/*" element={<AiAssistantView />} />
      <Route path="settings/user/*" element={<UserSettingsView />} />
      <Route path="system/pipelines" element={<SystemPage />} />
      <Route path="system/dead-letters" element={<DeadLettersPage />} />
      <Route path="system/email-builder" element={<EmailBuilderPage />} />
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
};

export default AuthenticatedRoutes;
